import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5 from '@fullcalendar/bootstrap5';
import esLocale from '@fullcalendar/core/locales/es';
import './Calendar.scss';

export default function Calendar(props) {
    return <FullCalendar
        plugins={[dayGridPlugin, bootstrap5]}
        themeSystem="bootstrap5"
        initialView="dayGridMonth"
        contentHeight="auto"
        fixedWeekCount={false}
        locale={esLocale}
        {...props} />;
}
